import { useState, useEffect } from "react";
import axios from "axios";
import useLoader from "./useLoader";

const useFetchCount = (url, dataKey) => {
  const [count, setCount] = useState(0);
  const { loading, showLoader, hideLoader } = useLoader();

  useEffect(() => {
    const fetchData = async () => {
      try {
        showLoader();
        const response = await axios.get(url);
        setCount(response?.data?.[dataKey]);
      } catch (error) {
      } finally {
        hideLoader();
      }
    };

    fetchData();
  }, [url, dataKey]);

  return { count, loading };
};

export default useFetchCount;
